import React from 'react';
import { Text } from '@chakra-ui/core';
import { format, parseISO } from 'date-fns';

const ActionAge = ({ detail, showDate = false, color = 'semiDarkGray.600' }) => {
  if (!detail) return null;
  const date = detail.since ? parseISO(detail.since) : null;
  const source =
    date && !Number.isNaN(date.getTime())
      ? `${detail.dateLabel || 'Date de référence'} : ${format(date, 'dd/MM/yyyy')}`
      : undefined;
  return (
    <Text as="span" display="block" fontSize="xs" fontWeight="normal" color={color} title={source}>
      {detail.ageDays == null
        ? 'Ancienneté non renseignée'
        : `En attente depuis ${detail.ageDays} jour${detail.ageDays > 1 ? 's' : ''}`}
      {showDate && source && (
        <Text as="span" display="block">
          {source}
        </Text>
      )}
    </Text>
  );
};

export default ActionAge;
